import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/UltimateGuideSMPSHero-bg.webp";
import ArticleImg        from "../../asset/images/news/article-17.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .ugs { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .ugs-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden; 
  }
  .ugs-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .ugs-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .ugs-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .ugs-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 520px;
  }
  .ugs-hero-divider {
    width: 479px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .ugs-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .ugs-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .ugs-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .ugs-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .ugs-bc-item:hover { color: #EB2019; }
  .ugs-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .ugs-bc-sep img { width: 24px; height: 24px; display: block; }
  .ugs-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .ugs-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .ugs-main-section { padding: 80px 0 120px 0; }
  .ugs-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .ugs-article { flex: 1; min-width: 0; }

  .ugs-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .ugs-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .ugs-meta-item:last-child { border-right: none; padding-right: 0; }
  .ugs-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .ugs-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  .ugs-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  .ugs-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .ugs-article-body p { margin-bottom: 20px; }
  .ugs-article-body p:last-child { margin-bottom: 0; }

  /* Bold section headings */
  .ugs-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 5px 0 15px 0; line-height: 160%; display: block;
  }

  /* Numbered sub-headings */
  .ugs-h3 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 20px 0 10px 0; line-height: 160%; display: block;
  }

  /* Bullet list */
  .ugs-article-body ul {
    list-style: none; margin: 0 0 30px 0; padding: 0;
    display: flex; flex-direction: column; gap: 15px;
  }
  .ugs-article-body ul li {
    display: flex; align-items: flex-start; gap: 10px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .ugs-article-body ul li::before {
    content: '•'; color: #202020;
    font-size: 16px; line-height: 160%; flex-shrink: 0;
  }
  .ugs-article-body ul li > span { flex: 1; }

  .ugs-article-body strong { font-weight: 600; color: #202020; }

  .ugs-red-link { color: #EB2019; text-decoration: underline; font-weight: 600; }
  .ugs-red-link:hover { opacity: 0.8; }

  /* ══ BOTTOM ROW ══ */
  .ugs-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .ugs-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .ugs-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .ugs-nav-btn:hover { color: #EB2019; }
  .ugs-nav-btn img { width: 40px; height: 40px; display: block; }

  .ugs-share-icons { display: flex; align-items: center; gap: 20px; }
  .ugs-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .ugs-share-icon:hover { opacity: 0.85; }
  .ugs-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .ugs-sidebar { flex: 0 0 475px; }
  .ugs-sidebar-block { margin-bottom: 60px; }
  .ugs-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .ugs-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .ugs-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .ugs-recent-item:hover .ugs-recent-title { color: #EB2019; }
  .ugs-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .ugs-recent-body { flex: 1; min-width: 0; }
  .ugs-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .ugs-social-icons { display: flex; align-items: center; gap: 30px; }
  .ugs-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .ugs-social-icon:hover { opacity: 0.8; }
  .ugs-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .ugs-hero             { height: 350px; }
    .ugs-hero-content     { padding: 0 32px; }
    .ugs-hero-title       { font-size: 30px; }
    .ugs-hero-divider     { width: 100%; max-width: 479px; }
    .ugs-breadcrumb       { padding: 24px 0 0 0; }
    .ugs-breadcrumb-inner { padding: 0 32px; }
    .ugs-inner            { padding: 0 32px; }
    .ugs-main-section     { padding: 48px 0 60px 0; }
    .ugs-main-row         { flex-direction: column; gap: 48px; }
    .ugs-sidebar          { flex: none; width: 100%; }
    .ugs-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .ugs-hero             { height: 360px; }
    .ugs-hero-content     { padding: 0 16px; }
    .ugs-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .ugs-hero-divider     { width: 100%; }
    .ugs-hero-subtitle    { font-size: 14px; }
    .ugs-breadcrumb       { padding: 30px 0 0 0; }
    .ugs-breadcrumb-inner { padding: 0 16px; }
    .ugs-bc-item          { font-size: 14px; gap: 14px; }
    .ugs-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .ugs-bc-sep img       { width: 22px; height: 22px; }
    .ugs-inner            { padding: 0 16px; }
    .ugs-main-section     { padding: 30px 0 60px 0; }
    .ugs-main-row         { flex-direction: column; gap: 60px; }
    .ugs-sidebar          { flex: none; width: 100%; }
    .ugs-article-title    { font-size: 20px; margin-bottom: 15px; }
    .ugs-article-body     { font-size: 14px; }
    .ugs-article-body p   { margin-bottom: 15px; }
    .ugs-article-body ul li { font-size: 14px; }
    .ugs-meta-item        { font-size: 14px; }
    .ugs-article-img      { margin: 30px 0 15px 0; height: 250px; }
    .ugs-h2               { font-size: 16px; margin: 30px 0 15px 0; }
    .ugs-h3               { font-size: 14px; margin: 15px 0 10px 0; }
    .ugs-nav-btn img      { width: 24px; height: 24px; }
    .ugs-nav-btn          { font-size: 14px; }
    .ugs-share-icon img   { width: 34px; height: 34px; }
  }
`;

const recentPosts = [
  {
    img: RecentImg1,
    title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
    slug: "battery-formation-testing-enabling-rise-ev-energy-storage-manufacturing",
  },
  {
    img: RecentImg2,
    title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
    slug: "next-gen-esp-power-supplies-upgrades-sustainability-industrial-air-pollution-control",
  },
  {
    img: RecentImg3,
    title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
    slug: "green-hydrogen-power-electronics-ador-powertron-forefront-electrolyzer-rectifier-setups",
  },
  {
    img: RecentImg4,
    title: "Transformer Bushings: Types & Importance",
    slug: "transformer-bushings-types-importance",
  },
];

export default function UltimateGuideSwitchModePowerSupply() {
  return (
    <div className="ugs">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="ugs-hero">
        <img className="ugs-hero-bg" src={HeroBgImg} alt="Ultimate Guide SMPS Hero" />
        <div className="ugs-hero-overlay" />
        <div className="ugs-hero-content">
          <h1 className="ugs-hero-title">
            The Ultimate Guide to Switch Mode Power Supply: Powering the Future of Electronics
          </h1>
          <hr className="ugs-hero-divider" />
          <p className="ugs-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="ugs-breadcrumb" aria-label="Breadcrumb">
        <div className="ugs-breadcrumb-inner">
          <a href="/" className="ugs-bc-item">Home</a>
          <span className="ugs-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="ugs-bc-item">News &amp; Updates</a>
          <span className="ugs-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="ugs-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="ugs-main-section">
        <div className="ugs-inner">
          <div className="ugs-main-row">

            {/* ── ARTICLE ── */}
            <article className="ugs-article">

              {/* Meta bar */}
              <div className="ugs-meta-bar">
                <span className="ugs-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="ugs-meta-item"><img src={CalendarIcon} alt="date" /> April 28, 2025</span>
                <span className="ugs-meta-item"><img src={ClockIconImg} alt="time" /> 9:21 am</span>
                <span className="ugs-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="ugs-article-title">
                The Ultimate Guide to Switch Mode Power Supply: Powering the Future of Electronics
              </h1>

              {/* Body */}
              <div className="ugs-article-body">

                <p>Efficient and reliable electronic power supply systems are critical to driving electronics performance. One such innovation that has become a cornerstone in modern electronics is the <a href="/smps" className="ugs-red-link">Switched-Mode Power Supply</a> (SMPS). From powering household appliances to supporting the latest mobile devices and industrial machinery, SMPS plays a vital role in power conversion to enhance performance, reduce heat generation, and improve efficiency.</p>

                <p>In this guide, we will explore the working principles of SMPS, its advantages over linear power supply systems, various applications, and why it's the go-to solution for engineers and manufacturers worldwide.</p>

                <p>IGBT modules are commonly used in applications such as motor drives, renewable energy systems (like solar inverters and wind turbines), uninterruptible power supplies (UPS), electric vehicles, and industrial power control systems. Their robust design allows them to handle high voltages (often in the range of hundreds to thousands of volts) and currents efficiently, making them ideal for demanding environments. Advanced modules may also include features like temperature sensors, gate drivers, and protection circuits to enhance reliability and simplify system integration.</p>

                {/* Article image */}
                <img className="ugs-article-img" src={ArticleImg} alt="Switch Mode Power Supply" />

                <span className="ugs-h2">What is an SMPS?</span>

                <p>A Switched Mode Power Supply (SMPS) uses a switching regulator to convert electrical power efficiently. Unlike linear power supplies, which dissipate excess voltage as heat, SMPS power supplies employ high frequency switching to adjust the output voltages and minimize losses. The result is a much more energy-efficient design that operates cooler and is smaller in size.</p>

                <span className="ugs-h2">Key Components of SMPS:</span>

                <ul>
                  <li><span>Switching Transistor: Acts as the gatekeeper, turning on and off to regulate power flow through controlled duty cycles.</span></li>
                  <li><span>Inductor: Stores energy during switching cycles and helps smooth the output.</span></li>
                  <li><span>Capacitor: Filters the output, providing a stable dc voltage.</span></li>
                  <li><span>Diode: Directs current flow and protects the system from short circuits and reverse current.</span></li>
                </ul>

                <p>These components work in harmony to deliver a high-performance dc switch mode solution with superior reliability.</p>

                <p><a href="/industrial-smps-solutions" className="ugs-red-link">How Industrial SMPS Solutions: Powering the Future of Industrial Automation and Pollution Control?</a></p>

                <span className="ugs-h2">Advantages of SMPS Over Traditional Power Supplies</span>

                <p>When comparing SMPS with traditional ac dc power supply systems, it's clear why SMPS is the preferred option. Here are the key benefits:</p>

                <span className="ugs-h3">1. Higher Efficiency</span>
                <p>One of the most significant advantages of SMPS is its higher efficiency. Linear power supplies often waste energy by converting excess voltage into heat. SMPS uses switching transistors and high frequency switching to drastically reduce energy losses, resulting in efficient dc conversion.</p>

                <span className="ugs-h3">2. Compact Design</span>
                <p>SMPS allows for smaller and lighter designs, ideal for devices like smartphones, laptops, and gaming consoles where space is limited.</p>

                <span className="ugs-h3">3. Reduced Heat Generation</span>
                <p>The efficient power conversion process generates less heat, reducing the need for large heat sinks and extending component life.</p>

                <span className="ugs-h3">4. Wide Input Voltage Range</span>
                <p>SMPS units can accept a broad input voltage range, making them adaptable to various ac dc power supply requirements around the world. They often include power factor correction inputs to optimize energy use and meet regulatory standards.</p>

                <span className="ugs-h2">How Does a Switched-Mode Power Supply Work?</span>

                <p>Understanding how SMPS works helps clarify its advantages. Here's a breakdown of the dc power supplies process:</p>

                <span className="ugs-h3">Step 1: AC Input</span>
                <p>The process starts with an input voltage from the mains power source.</p>

                <span className="ugs-h3">Step 2: Rectification</span>
                <p>The ac voltage is converted into dc voltage through rectification using diodes.</p>

                <span className="ugs-h3">Step 3: Switching</span>
                <p>A switching transistor then chops the dc voltage at a high frequency, controlling the duty cycle to regulate output.</p>

                <span className="ugs-h3">Step 4: Energy Storage</span>
                <p>The chopped signal is sent through an inductor or transformer to store and transfer energy efficiently.</p>

                <span className="ugs-h3">Step 5: Output Filtering</span>
                <p>Finally, capacitors filter the signal to deliver stable dc output voltages. This method of dc conversion allows for compact, efficient electronic power supply designs.</p>

                <span className="ugs-h2">Types of SMPS Topologies</span>

                <p>Different power demands call for different dc switch mode topologies. Common designs include:</p>

                <span className="ugs-h3">1. Buck Converter</span>
                <p>Buck converters step down voltage, ideal for low-voltage dc power supplies in battery-powered devices.</p>

                <span className="ugs-h3">2. Boost Converter</span>
                <p>Boost converters step up input voltage, useful in applications like portable chargers.</p>

                <span className="ugs-h3">3. Buck-Boost Converter</span>
                <p>This topology can step voltage up or down, providing flexibility for varying dc output voltages.</p>

                <span className="ugs-h3">4. Flyback Converter</span>
                <p>Used in ac dc power supply adapters and chargers, flyback converters offer isolation and multiple output options.</p>

                <p>Each topology utilizes a switching regulator to manage power efficiently based on the application.</p>

                <span className="ugs-h2">Applications of SMPS Power Supplies</span>

                <p>SMPS technology is widely adopted across various industries:</p>

                <span className="ugs-h3">1. Consumer Electronics</span>
                <p>Used in smartphones, TVs, and laptops, SMPS offers compact, efficient electronic power supply solutions.</p>

                <span className="ugs-h3">2. Telecommunications</span>
                <p>Base stations, routers, and other telecom infrastructure rely on SMPS for reliable dc power supplies, especially in regions with variable input voltage conditions.</p>

                <span className="ugs-h3">3. Industrial Applications</span>
                <p>Automation systems and factory equipment benefit from SMPS's high efficiency and robustness against short circuits and voltage fluctuations.</p>

                <span className="ugs-h3">4. Medical Devices</span>
                <p>Diagnostic tools and sensitive medical electronics depend on stable, heat-efficient dc switch mode systems to operate safely and reliably.</p>

                <span className="ugs-h3">5. Power Adapters and Chargers</span>
                <p>Most consumer ac dc power supply adapters today are built using SMPS due to their portability and global compatibility.</p>

                <span className="ugs-h2">Why SMPS is the Future of Power Conversion</span>

                <p>As energy demands increase, SMPS remains vital in delivering efficient, scalable power conversion. With advancements in switching transistor technology and power factor corrected designs, SMPS continues to evolve for next-gen electronic needs.</p>

                <span className="ugs-h2">Key Takeaways:</span>

                <ul>
                  <li><span>SMPS offers better efficiency, smaller size, and less heat than linear power supply options.</span></li>
                  <li><span>Various topologies like buck converters, boost, and flyback meet diverse power needs.</span></li>
                  <li><span>SMPS is used across consumer, telecom, industrial, and medical sectors.</span></li>
                  <li><span>With advanced switching regulator techniques and dc conversion innovations, SMPS is the foundation of tomorrow's electronics.</span></li>
                </ul>

                <span className="ugs-h2">Ready to Optimize Your Power Conversion?</span>

                <p>If you're designing electronics and want to leverage the benefits of dc switch mode technology, reach out for a consultation. From dc power supplies to full-scale ac dc power supply systems, we help you build efficient and future-ready solutions.</p>

                <p><a href="/contact" className="ugs-red-link">Contact Us Today</a> to discuss how SMPS can elevate your next project.</p>

                <span className="ugs-h2">Need a Custom SMPS Solution?</span>

                <p>Explore our custom power supply offerings designed to meet your exact requirements.</p>

                <span className="ugs-h2">Conclusion</span>

                <p>The switched mode power supply SMPS is revolutionizing electronic power supply design. Its efficiency, compactness, and flexibility make it essential in modern electronics.</p>

              </div>

              {/* ── Bottom row ── */}
              <div className="ugs-bottom-row">
                <div className="ugs-bottom-nav">
                  <a href="/news/previous" className="ugs-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/next" className="ugs-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="ugs-share-icons">
                  <a href="#" className="ugs-share-icon" aria-label="Facebook">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="#" className="ugs-share-icon" aria-label="Twitter">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="#" className="ugs-share-icon" aria-label="LinkedIn">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="ugs-sidebar">

              {/* Recent Posts */}
              <div className="ugs-sidebar-block">
                <p className="ugs-sidebar-title">Recent Posts</p>
                <div className="ugs-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="ugs-recent-item">
                      <img src={post.img} alt={post.title} className="ugs-recent-img" />
                      <div className="ugs-recent-body">
                        <span className="ugs-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="ugs-sidebar-block">
                <p className="ugs-sidebar-title">Social Media</p>
                <div className="ugs-social-icons">
                  <a href="#" className="ugs-social-icon" aria-label="YouTube">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="#" className="ugs-social-icon" aria-label="LinkedIn">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}